import { CONFIG } from "./CONFIG";

/**
 * Which period the Insights tab lands on: the
 * latest month with ENOUGH data to score — "all time" has no earlier
 * window, a whole year compares against just the year before, and the
 * current month is usually a few days old (one of two observations is not
 * a 50% share). Falls back to the latest month with any data.
 */
export const latestUsableMonthOption = (periodOptions, totalsByMonth) => {
  const months = (periodOptions || [])
    .filter((o) => /^month_\d{4}_\d{2}$/.test(o.value))
    .sort((a, b) => a.value.localeCompare(b.value));
  const keyOf = (o) => o.value.replace(/^month_(\d{4})_(\d{2})$/, "$1-$2");
  const usable = months.filter((o) => (totalsByMonth?.[keyOf(o)] || 0) >= CONFIG.MIN_NOW_TOTAL);
  return usable.pop() || months.pop() || null;
};
